import * as xlsx from "xlsx";

// Visible text of a cell, used only to size the columns.
const cellText = (cell) => {
  if (cell && typeof cell === "object") return String(cell.v ?? "");
  return String(cell ?? "");
};

/**
 * One workbook from `buildStatsSheets` output. Columns are sized to their longest value (capped, so
 * a long club name cannot make a column absurdly wide).
 */
export const buildWorkbook = (sheets) => {
  const workbook = xlsx.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    const sheet = xlsx.utils.aoa_to_sheet(rows);
    const columns = Math.max(0, ...rows.map((row) => row.length));
    sheet["!cols"] = Array.from({ length: columns }, (_, c) => ({
      wch: Math.min(48, Math.max(8, ...rows.map((row) => cellText(row[c]).length)) + 2),
    }));
    xlsx.utils.book_append_sheet(workbook, sheet, name);
  });
  return workbook;
};

/** Builds the workbook and triggers the browser download. */
export const downloadStatsWorkbook = (sheets, fileName) => {
  xlsx.writeFile(buildWorkbook(sheets), fileName);
};
